import api from 'config/api/protectedApi';
import { apiRoutes } from 'config/api/apiRoutes';
import useError from 'utils/useError';
import { IProfile } from 'models/profileModel';

export async function getUserData(): Promise<IProfile> {
    return api.get(apiRoutes.getUserData)
        .then(response => response.data)
        .catch(error => { throw error });
}

export async function getPreferredLanguage(): Promise<string> {
    return api.get(apiRoutes.getPreferredLanguage)
        .then(response => response.data)
        .catch(error => { throw error });
}

export const useProfileApi = () => {
    const { throwException } = useError()

    async function updateProfileInfo(profile: IProfile): Promise<IProfile> {
        const data = { ...profile };

        return api.put(apiRoutes.updateProfileInfo, data)
            .then(() => profile)
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function getPreferredLanguage(): Promise<string> {
        return api.get(apiRoutes.getPreferredLanguage)
            .then((response) => response.data)
            .catch(error => { throw error });
    }

    async function updatePreferredLanguage(language: string): Promise<boolean> {
        return api.put(apiRoutes.updatePreferredLanguage, {
            language: language
        })
            .then(() => true)
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function requestEmailVerificationCode(email: string): Promise<boolean> {
        const data = {
            newEmail: email
        }
        return api.post(apiRoutes.requestEmailVerificationCode, data)
            .then(() => true)
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function verifyProfileEmail(email: string, verificationCode: string): Promise<string> {
        const data = {
            newEmail: email,
            verificationCode: verificationCode
        }
        return api.post(apiRoutes.verifyProfileEmail, data)
            .then((response) => {
                const numberId = response.data as string
                return numberId
            })
            .catch(error => {
                throwException(error)
                throw error
            });
    }



    async function requestMobileVerificationCode(fullNumber: string, recaptchaToken:string, countryCodeId:number): Promise<boolean> {
        const data = {
            fullNumber: fullNumber,
            recaptchaToken: recaptchaToken,
            countryCodeId:countryCodeId
        }
        return api.post(apiRoutes.requestMobileVerificationCode, data)
            .then(() => true)
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function verifyProfileMobile(mobileNumber: string, mobileCountryId: number, fullMobileNumber: string, verificationCode: string): Promise<string> {
        const data = {
            mobileNumber: mobileNumber,
            mobileCountryId: mobileCountryId,
            fullMobileNumber: fullMobileNumber,
            verificationCode: verificationCode
        }
        return api.post(apiRoutes.verifyProfileMobile, data)
            .then((response) => {
                const numberId = response.data as string
                return numberId
            })
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    return {
        updateProfileInfo, 
        getPreferredLanguage, updatePreferredLanguage,
        requestEmailVerificationCode, verifyProfileEmail,
        requestMobileVerificationCode, verifyProfileMobile
    }
} 